<template>
  <Table
    :columns="columns"
    @sort="sortBy = $event"
    :rows="rowsModified"
    :sortBy="sortBy"
    :isServiceModal="isServiceModal"
    class="services-list-table"
    v-if="rowsModified && rowsModified.length"
  >
    <template #td="{ row, col, i, clickHandler }">
      <td
        v-if="col.label === 'name'"
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
      >
        <button
          v-if="!isServiceModal"
          type="button"
          class="table__open"
          @click="clickHandler(i)"
        >
          <icon name="arrow-down" />
        </button>

        <button
          v-if="
            row.is_required_quantity_by_date ||
              row.is_required_time_range_by_date
          "
          type="button"
          class="table__left-button services-list-table__quantity-by-date"
          @click="showAdditionalParamTab(i, clickHandler)"
          :style="{
            transform: additionalParamTab === i ? 'rotate(180deg)' : 'none'
          }"
        >
          <icon name="arrow-down" />
        </button>

        <a class="table-item-name" @click.prevent="showService(row)" href="#">
          {{ row | localeField(col.label, "—") }}
        </a>
      </td>
      <td
        v-if="col.label === 'unit'"
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
      >
        <button
          v-if="!isServiceModal"
          type="button"
          class="table__open"
          @click="clickHandler(i)"
        >
          <icon name="arrow-down" />
        </button>
        <span> {{ getUnit(row) }} </span>
      </td>
      <td
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
        v-else-if="col.label === 'count'"
      >
        <span
          v-if="
            !row.is_required_stand_area &&
              !row.is_required_quantity_by_date &&
              !row.is_required_time_range_by_date
          "
        >
          <InputNumber
            v-model="row.count"
            :disabled="isLoading(row)"
            :init-value="inCartCount(row)"
            :min="row.min_count || 1"
            @input="componentKey++"
            @debounceInput="handleDebounce(row)"
          />
        </span>
        <span
          v-else
          @click="
            row.is_required_quantity_by_date ||
            row.is_required_time_range_by_date
              ? showAdditionalParamTab(i, clickHandler)
              : () => {}
          "
        >
          {{ row.count }}
        </span>
      </td>
      <td
        v-else-if="col.label === 'date'"
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
      >
        <span>
          <DatePicker
            align-right
            :value="getServiceDate(row)"
            :available-periods="getServiceAvailablePeriods(row)"
            @input="setServiceDate(row, $event)"
            v-if="
              !row.is_required_quantity_by_date &&
                !row.is_required_time_range_by_date &&
                (row.is_required_date_install ||
                  row.is_required_date_exhibition ||
                  row.is_required_date_dismantling)
            "
          >
            <template #input="{ visibilityToggler }">
              <tooltip :label="$t('services.cart.chooseDate')">
                <button
                  type="button"
                  class="primary-button services-list-table__button"
                  @click="visibilityToggler()"
                >
                  <icon name="calendar" />
                  <span class="services-list-table__button-counter">
                    {{ selectedDatesCount(row) }}
                  </span>
                </button>
              </tooltip>
            </template>
          </DatePicker>
          <template v-else>-</template>
        </span>
      </td>
      <td
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
        v-else-if="col.label === 'price'"
      >
        <span>
          {{ getPrice(row) | formatPrice }}
        </span>
      </td>
      <td
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
        v-else-if="col.label === 'sum'"
        :key="componentKey"
      >
        <span>
          {{ getSum(row) | formatPrice }}
        </span>
      </td>
      <td
        :class="{
          'active-top':
            additionalParamTab === i ||
            (popularVisible === i && row.related_services.length)
        }"
        v-else-if="col.label === 'action' && col.action"
      >
        <tooltip :label="$t('services.addToCart')">
          <button
            v-if="!isCart && !isServiceInCart(row)"
            type="button"
            class="primary-button services-list-table__button services-list-table__button--light"
            @click="addToCart(row, i, clickHandler)"
          >
            <LoadingIcon v-if="isLoading(row)" />
            <template v-else>
              <icon name="cart" />
            </template>
          </button>
        </tooltip>

        <tooltip :label="$t('services.cart.deleteFromCart')">
          <button
            v-if="isServiceInCart(row)"
            type="button"
            class="services-list-table__button services-list-table__button--delete button-clean"
            @click="deleteFromCart(row)"
          >
            <LoadingIcon v-if="isLoading(row)" />
            <icon v-else name="close" />
          </button>
        </tooltip>
      </td>
    </template>
    <template #row-header="{ row, columns, i }">
      <tr v-if="row.executor && row.showExecutor">
        <td :colspan="columns.length" class="table__expand">
          <div class="services-list-table__executor">
            {{ row.executor | localeField("name") }}
          </div>
        </td>
      </tr>
    </template>
    <template #m-row="{ row, columns, i}">
      <td
        :class="{
          'active-left': popularVisible === i && row.related_services.length
        }"
        :colspan="columns.length"
      >
        <div class="services-list-table__form">
          <div
            class="services-list-table__form-row"
            v-for="(col, i) in columns.filter(c => !c.showMobile)"
            :key="i"
          >
            <template v-if="col.label === 'count'">
              <span>{{ col | localeField("title") }}</span>
              <InputNumber
                v-if="
                  !row.is_required_stand_area &&
                    !row.is_required_quantity_by_date &&
                    !row.is_required_time_range_by_date
                "
                v-model="row.count"
                :disabled="isLoading(row)"
                :init-value="inCartCount(row)"
                :min="row.min_count || 1"
                @input="componentKey++"
                @debounceInput="handleDebounce(row)"
              />
              <span v-else>
                {{ row.count }}
              </span>
            </template>
            <template v-else-if="col.label === 'action' && !isCart">
              <button
                type="button"
                class="primary-button services-list-table__button services-list-table__button--light services-list-table__button--wide"
                @click="addToCart(row)"
              >
                <span class="icon">
                  <LoadingIcon v-if="isLoading(row)" />
                  <template v-else>
                    <icon name="cart" />
                    <span class="services-list-table__button-counter">
                      {{ inCartCount(row) }}
                    </span>
                  </template>
                </span>
                <span>
                  {{ $t("services.addToCart") }}
                </span>
              </button>
            </template>
            <template v-else-if="col.label === 'action' && isCart">
              <button
                v-if="col.action === 'delete'"
                type="button"
                class="primary-button services-list-table__button services-list-table__button--light services-list-table__button--wide"
                @click="deleteFromCart(row)"
              >
                <span>{{ $t("services.cart.deleteFromCart") }}</span>
                <LoadingIcon v-if="isLoading(row)" />
                <icon v-else name="close" />
              </button>
            </template>
            <template v-else-if="col.label === 'date'">
              <span>{{ col | localeField("title") }}</span>
              <DatePicker
                align-right
                :value="getServiceDate(row)"
                :available-periods="getServiceAvailablePeriods(row)"
                @input="setServiceDate(row, $event)"
                v-if="
                  !row.is_required_quantity_by_date &&
                    !row.is_required_time_range_by_date &&
                    (row.is_required_date_install ||
                      row.is_required_date_exhibition ||
                      row.is_required_date_dismantling)
                "
              >
                <template #input="{ visibilityToggler }">
                  <button
                    type="button"
                    class="primary-button services-list-table__button"
                    @click="visibilityToggler()"
                  >
                    <icon name="calendar" />
                    <span class="services-list-table__button-counter">{{
                      selectedDatesCount(row)
                    }}</span>
                  </button>
                </template>
              </DatePicker>
              <template v-else>-</template>
            </template>
            <template v-else-if="col.label === 'unit'">
              <span>{{ col | localeField("title") }}</span>
              <div>{{ getUnit(row) }}</div>
            </template>
            <template v-else-if="col.label === 'sum'">
              <span>{{ col | localeField("title") }}</span>
              <div :key="componentKey">{{ getSum(row) | formatPrice }}</div>
            </template>
            <template v-else>
              <span>{{ col | localeField("title") }}</span>
              <div>{{ row[col.label] || "-" }}</div>
            </template>
          </div>
        </div>
      </td>
    </template>

    <template #row-extension="{ row, columns, i }">
      <tr
        v-show="
          (row.is_required_quantity_by_date ||
            row.is_required_time_range_by_date) &&
            additionalParamTab === i
        "
        v-for="(availableDate, cbdiKey) in getServiceAvailableDates(row)"
        :key="`${row.id}-${cbdiKey}-${componentKey}-countByDates`"
        :class="[
          {
            'active-left-and-right': additionalParamTab === i,
            'active-bottom':
              additionalParamTab === i &&
              cbdiKey === getServiceAvailableDates(row).length - 1
          },
          setBackgroundColor(availableDate)
        ]"
      >
        <td
          v-for="column in columns"
          :key="`${column.label}-countByDateColumn`"
          :class="{
            'no-wrap': column.label === 'date'
          }"
        >
          <template v-if="column.label === 'count'">
            <InputNumber
              v-if="row.is_required_quantity_by_date"
              :min="0"
              :disabled="isLoading(row)"
              :value="getServiceQuantityByDateCount(row, availableDate)"
              @input="value => syncQuantityByDate(row, value, availableDate)"
            />
            <template v-else-if="row.is_required_time_range_by_date">
              <tooltip
                @close="recalculateRowCountAfterChangeTimeRangeByDate(row)"
                clickable
              >
                <tooltip :label="$t('services.cart.chooseTimeRange')">
                  <div class="time-wrap">
                    <button
                      type="button"
                      class="primary-button services-list-table__button"
                    >
                      <icon name="time" />
                      <span class="services-list-table__button-counter">
                        {{ getServiceTimeRangeByDateCount(row, availableDate) }}
                      </span>
                    </button>
                  </div>
                </tooltip>

                <template #content>
                  <div class="services-list-table__time-range--tooltip">
                    <div
                      class="services-list-table__time-range--content"
                      style="margin-right: 15px"
                    >
                      <checkbox
                        class="services-list-table__time-range--content__checkbox"
                        v-for="availableTimeRange in availableTimeRangeList"
                        :key="`time-range-${availableTimeRange}`"
                        :disabled="
                          isDisabledTimeRangeByDate(
                            row,
                            availableDate,
                            availableTimeRange
                          )
                        "
                        :value="
                          isTimeInTimeRangeByDate(
                            row,
                            availableDate,
                            availableTimeRange
                          )
                        "
                        @input="
                          value =>
                            syncTimeRangeByDate(
                              value,
                              row,
                              availableTimeRange,
                              availableDate
                            )
                        "
                      >
                        {{ availableTimeRange }}:00 -
                        {{ availableTimeRange + 2 }}:00
                      </checkbox>
                    </div>
                    <div class="services-list-table__time-range--content">
                      <checkbox
                        class="services-list-table__time-range--content__checkbox"
                        v-for="availableTimeRange in secondAvailableTimeRangeList"
                        :key="`time-range-${availableTimeRange}`"
                        :disabled="
                          isDisabledTimeRangeByDate(
                            row,
                            availableDate,
                            availableTimeRange
                          )
                        "
                        :value="
                          isTimeInTimeRangeByDate(
                            row,
                            availableDate,
                            availableTimeRange
                          )
                        "
                        @input="
                          value =>
                            syncTimeRangeByDate(
                              value,
                              row,
                              availableTimeRange,
                              availableDate
                            )
                        "
                      >
                        {{ availableTimeRange }}:00 -
                        {{ availableTimeRange + 2 }}:00
                      </checkbox>
                    </div>
                  </div>
                </template>
              </tooltip>
            </template>
          </template>
          <template v-if="column.label === 'date'">{{
            availableDate | formatDate
          }}</template>
        </td>
      </tr>
      <tr
        v-if="isShowRelatedOrShortDescription(row)"
        :class="{
          'active-bottom': popularVisible === i && row.related_services.length
        }"
      >
        <td :colspan="columns.length" class="table__expand">
          <Notification
            style="font-size: 14px"
            v-if="$options.filters.localeField(row, 'short_description').length"
            icon="warning-border--no-color"
            modify="_flex"
          >
            <span
              v-html="$options.filters.localeField(row, 'short_description')"
            ></span>
          </Notification>
          <div
            class="services-list-table__popular"
            v-if="row.related_services?.length"
          >
            <button
              type="button"
              class="services-list-table__popular-header"
              :class="{
                'services-list-table__popular-header--open':
                  popularVisible === i
              }"
              @click="
                popularVisible === i
                  ? (popularVisible = null)
                  : (popularVisible = i)
              "
            >
              <span> {{ $t("services.recommendedService") }}</span>
              <icon name="arrow-down_grey" />
            </button>
            <EventPopularServicesList
              class="services-list-table__popular-list"
              :list="row.related_services"
              v-if="popularVisible === i"
              :parentId="row.id"
              white
            />
          </div>
        </td>
      </tr>
      <tr v-if="isCart">
        <td :colspan="columns.length" class="table__expand">
          <div class="services-list-table__comment">
            <span class="services-list-table__comment-title">
              {{ $t("services.cart.comment") }}
            </span>
            <textarea-autosize
              v-model="row.comment"
              class="input textarea services-list-table__comment-field"
              :placeholder="$t('services.cart.commentInputPlaceholder')"
              :min-height="50"
              @blur.native="addToCart(row)"
            />
          </div>
        </td>
      </tr>
    </template>
  </Table>
</template>

<script>
import EventPopularServicesList from "@/components/Custom/EventPopularServicesList.vue";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import apiCart from "@/api/cart";
import { i18n } from "@v2/shared/config";
import { enumerateDaysBetweenDates } from "@/helpers/common";

import {
  Tooltip,
  Checkbox,
  InputNumber,
  LoadingIcon,
  DatePicker,
  Notification,
  Table
} from "@v2/shared/ui/components";
moment.locale(i18n.locale);

export default {
  name: "ServiceListTableComponent",
  components: {
    Notification,
    Checkbox,
    Tooltip,
    EventPopularServicesList,
    DatePicker,
    LoadingIcon,
    InputNumber,
    Table
  },
  props: {
    rows: Array,
    action: {
      type: String,
      default: "cart"
    },
    isCart: Boolean,
    isServiceModal: Boolean
  },
  data() {
    return {
      columns: [
        {
          label: "name",
          title_rus: "Наименование",
          title_eng: "Name",
          showMobile: true,
          alignLeft: true
        },
        {
          label: "unit",
          title_rus: "Ед. изм.",
          title_eng: "Unit"
        },
        {
          label: "price",
          title_rus: "Цена",
          title_eng: "Price",
          showMobile: true
        },
        {
          label: "count",
          title_rus: "Количество",
          title_eng: "Number"
        },
        {
          label: "date",
          title_rus: "Дата",
          title_eng: "Date"
        },
        {
          label: "sum",
          title_rus: "Стоимость",
          title_eng: "Cost"
        },
        {
          label: "action",
          action: this.$props.action
        }
      ],
      componentKey: 0,
      loading: [],
      popularVisible: this.isServiceModal ? 0 : null,
      additionalParamTab: null,
      sortBy: null,
      quantityByDateDebounce: null,
      timeRangeByDateDebounce: null,
      availableTimeRangeList: [8, 10, 12, 14, 16, 18],
      secondAvailableTimeRangeList: [9, 11, 13, 15, 17]
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format(
        i18n.locale === "ru" ? "DD.MM.YYYY" : "MM/DD/YYYY"
      );
    }
  },
  computed: {
    ...mapState("event", ["event", "currentStand"]),
    ...mapState("services", ["cart"]),
    ...mapGetters("services", ["cartServicesList", "currency"]),

    exhibition() {
      return this.event ? this.event.exhibition : {};
    },
    // говнокод из-за того, что услуги с несколькими ценами нужно вывести по отдельности
    // и отправлять price_id для каждого при добавлении в корзину
    rowsModified() {
      if (this.isCart) {
        let rows = this.rows ? JSON.parse(JSON.stringify(this.rows)) : [];
        let modifiedRows = [];
        rows.forEach(row => {
          let quantityByDates = row?.quantity_by_dates || [];
          let timeRangeByDates = row?.time_range_by_dates || [];
          let count = row.count || 1;

          if (row.is_required_quantity_by_date) {
            quantityByDates = quantityByDates
              .map(quantityByDate => {
                return {
                  ...quantityByDate,
                  date: moment(quantityByDate.date).format("YYYY-MM-DD")
                };
              })
              .filter(
                quantityByDate =>
                  quantityByDate.quantity &&
                  this.getServiceAvailableDates(row).find(date =>
                    moment(date).isSame(moment(quantityByDate.date), "day")
                  )
              );

            count = quantityByDates.reduce((result, quantityByDate) => {
              return result + quantityByDate.quantity;
            }, 0);
          }

          if (row.is_required_time_range_by_date) {
            timeRangeByDates = timeRangeByDates
              .map(timeRangeByDate => {
                return {
                  ...timeRangeByDate,
                  date: moment(timeRangeByDate.date).format("YYYY-MM-DD")
                };
              })
              .filter(
                timeRangeByDate =>
                  timeRangeByDate?.time_range.length &&
                  this.getServiceAvailableDates(row).find(date =>
                    moment(date).isSame(moment(timeRangeByDate.date), "day")
                  )
              );

            count = timeRangeByDates.reduce((result, timeRangeByDate) => {
              return result + timeRangeByDate.time_range.length;
            }, 0);
          }

          modifiedRows.push({
            ...row,
            count: count,
            quantity_by_dates: quantityByDates,
            time_range_by_dates: timeRangeByDates
          });
        });

        return modifiedRows;
      } else {
        let rows = this.rows ? JSON.parse(JSON.stringify(this.rows)) : [];
        let modifiedRows = [];
        rows.forEach(item => {
          item.prices?.forEach(price => {
            if (this.currency && price.currency === this.currency.code) {
              const row = { ...item, price };
              const cartItem = this.cartItem(row);
              let count = cartItem.count || item.min_count || 1;
              let quantityByDates = cartItem?.quantity_by_dates || [];
              let timeRangeByDates = cartItem?.time_range_by_dates || [];

              if (row.is_required_stand_area && this.currentStand?.area)
                count = this.currentStand.area;

              if (row.is_required_quantity_by_date) {
                quantityByDates = quantityByDates
                  .map(quantityByDate => {
                    return {
                      ...quantityByDate,
                      date: moment(quantityByDate.date).format("YYYY-MM-DD")
                    };
                  })
                  .filter(
                    quantityByDate =>
                      quantityByDate.quantity &&
                      this.getServiceAvailableDates(row).find(date =>
                        moment(date).isSame(moment(quantityByDate.date), "day")
                      )
                  );

                count = quantityByDates.reduce((result, quantityByDate) => {
                  return result + quantityByDate.quantity;
                }, 0);
              }

              if (row.is_required_time_range_by_date) {
                timeRangeByDates = timeRangeByDates
                  .map(timeRangeByDate => {
                    return {
                      ...timeRangeByDate,
                      date: moment(timeRangeByDate.date).format("YYYY-MM-DD")
                    };
                  })
                  .filter(
                    timeRangeByDate =>
                      timeRangeByDate?.time_range.length &&
                      this.getServiceAvailableDates(row).find(date =>
                        moment(date).isSame(moment(timeRangeByDate.date), "day")
                      )
                  );

                count = timeRangeByDates.reduce((result, timeRangeByDate) => {
                  return result + timeRangeByDate.time_range.length;
                }, 0);
              }

              modifiedRows.push({
                ...row,
                count: count,
                dates: cartItem.dates,
                unit: price.unit,
                quantity_by_dates: quantityByDates,
                time_range_by_dates: timeRangeByDates
              });
            }
          });
        });
        return modifiedRows;
      }
    }
  },
  watch: {
    currentStand: {
      deep: true,
      handler() {
        this.rowsModified
          .filter(
            row => row.is_required_stand_area && this.isServiceInCart(row)
          )
          .forEach(row => this.handleDebounce(row));
      }
    }
  },
  methods: {
    checkDates(row) {
      return (
        !row.is_required_quantity_by_date &&
        !row.is_required_time_range_by_date &&
        (!row.dates || row.dates.length === 0) &&
        (row.is_required_date_install ||
          row.is_required_date_exhibition ||
          row.is_required_date_dismantling)
      );
    },

    handleDebounce(service) {
      if (this.isServiceInCart(service)) {
        this.addToCart(service);
      }
    },

    addToCart(service, i, clickHandler) {
      if (service.is_required_quantity_by_date) {
        if (!service?.quantity_by_dates?.some(item => item.date)) {
          this.showAdditionalParamTab(i, clickHandler);

          return;
        }
      }

      if (service.is_required_time_range_by_date) {
        if (!service?.time_range_by_dates?.some(item => item.date)) {
          this.showAdditionalParamTab(i, clickHandler);

          return;
        }
      }

      if (this.checkDates(service)) {
        this.$emit("showPopup");

        return;
      }

      if (this.isLoading(service)) return;
      this.loading.push(service);
      let inCart = !!this.inCartCount(service);
      let data = {
        quantity: service.count,
        dates: service.dates || [],
        quantity_by_dates: service.quantity_by_dates || null,
        time_range_by_dates: service.time_range_by_dates || null,
        unit_id: service.unit?.id || undefined,
        comment: service.comment || undefined
      };
      let itemId = inCart ? this.cartItem(service).cart_item_id : service.id;
      let request = inCart ? apiCart.update : apiCart.add;
      request(this.$route.params.id, itemId, data)
        .then(() => {
          this.updateCart(service);
        })
        .catch(() => {
          this.loading = [];
        });
    },

    deleteFromCart(service) {
      if (this.isLoading(service)) return;
      this.loading.push(service);
      let itemId = this.cartItem(service).cart_item_id;
      apiCart
        .delete(this.$route.params.id, itemId)
        .then(() => {
          this.updateCart(service);
          this.rowsModified.find(
            row => row.id === service.id
          ).quantity_by_dates = [];
        })
        .catch(() => {
          this.loading = [];
        });
    },

    updateCart(service) {
      this.$store
        .dispatch("services/getCart", this.$route.params.id)
        .finally(() => {
          let index = this.loading.findIndex(item => item.id === service.id);
          if (index !== -1) {
            this.loading.splice(index, 1);
          } else {
            this.loading = [];
          }
          this.componentKey++;
        });
    },

    isLoading(service) {
      return !!this.loading.find(
        item =>
          item.id === service.id &&
          item.unit.id ===
            (this.isCart ? service.unit?.id : service.price?.unit?.id)
      );
    },

    isServiceInCart(service) {
      return (
        !!this.cartServicesList.find(item => item?.id === service?.id) || false
      );
    },

    inCartCount(service) {
      return this.cartItem(service).count || 0;
    },

    cartItem(service) {
      return (
        this.cartServicesList.find(
          item =>
            item.id === service.id &&
            item.unit &&
            item.unit?.id ===
              (this.isCart ? service.unit?.id : service.price?.unit?.id)
        ) || {}
      );
    },

    selectedDatesCount(service) {
      return service.dates ? service.dates.length : 0;
    },

    getServiceDate(service) {
      return service.dates
        ? service.dates.map(date => moment(date).format("YYYY-MM-DD"))
        : [];
    },

    setServiceDate(service, dates) {
      service.dates = dates.map(date => moment(date).format("YYYY-MM-DD"));
      if (this.checkDates(service) && this.isServiceInCart(service)) {
        this.deleteFromCart(service);
      }
      if (
        this.isCart ||
        (this.isServiceInCart(service) && !this.checkDates(service))
      ) {
        this.addToCart(service);
      }
      this.componentKey++;
    },

    // Получение "Ед. из."
    getUnit(service) {
      const unit = this.isCart ? service.unit : service.price?.unit;
      return this.$options.filters.localeField(unit, "name");
    },

    // Получение цены
    getPrice(service) {
      if (this.isCart) {
        return service.currencyPrice
          ? parseFloat(service.currencyPrice.price_with_vat)
          : null;
      } else if (service.price) {
        return parseFloat(service.price.price_with_vat);
      }
      return null;
    },

    // Получение суммы
    getSum(service) {
      let price = this.getPrice(service);
      const datesCount = this.selectedDatesCount(service);
      const count = (service.count || 1) * (datesCount || 1);

      if (price) {
        return price * count;
      }

      return null;
    },

    // получаем доступные для выбора даты
    getServiceAvailablePeriods(service) {
      let dates = [];
      if (service.is_required_date_install) {
        dates.push({
          startDate: this.exhibition.installation_started_at,
          endDate: this.exhibition.installation_ended_at,
          type: "installation"
        });
      }
      if (service.is_required_date_exhibition) {
        dates.push({
          startDate: this.exhibition.started_at,
          endDate: this.exhibition.ended_at,
          type: "exhibition"
        });
      }
      if (service.is_required_date_dismantling) {
        dates.push({
          startDate: this.exhibition.dismantling_started_at,
          endDate: this.exhibition.dismantling_ended_at,
          type: "dismantling"
        });
      }
      return dates;
    },

    getServiceAvailableDates(service) {
      return this.getServiceAvailablePeriods(service).reduce(
        (result, period) => {
          return [
            ...result,
            ...enumerateDaysBetweenDates(
              moment(period.startDate),
              moment(period.endDate)
            )
          ];
        },
        []
      );
    },

    setBackgroundColor(date) {
      if (
        moment(date).isBetween(
          moment(this.exhibition.installation_started_at).format("MM-DD-YYYY"),
          moment(this.exhibition.installation_ended_at).format("MM-DD-YYYY"),
          undefined,
          "[]"
        ) ||
        moment(date).isBetween(
          moment(this.exhibition.dismantling_started_at).format("MM-DD-YYYY"),
          moment(this.exhibition.dismantling_ended_at).format("MM-DD-YYYY"),
          undefined,
          "[]"
        )
      ) {
        return "light-blue";
      }
      return "blue";
    },

    getServiceQuantityByDateCount(service, date) {
      return (
        service.quantity_by_dates?.find(item =>
          moment(item.date).isSame(moment(date), "day")
        )?.quantity || 0
      );
    },

    getServiceTimeRangeByDateCount(service, date) {
      return (
        service.time_range_by_dates?.find(item =>
          moment(item.date).isSame(moment(date), "day")
        )?.time_range?.length || 0
      );
    },

    isTimeInTimeRangeByDate(service, date, time) {
      return service.time_range_by_dates
        ?.find(item => moment(item.date).isSame(moment(date), "day"))
        ?.time_range?.includes(time);
    },

    isDisabledTimeRangeByDate(service, date, time) {
      const currentTimeRange = service.time_range_by_dates?.find(item =>
        moment(item.date).isSame(moment(date), "day")
      )?.time_range;

      return (
        this.isServiceInCart(service) &&
        service.time_range_by_dates.length === 1 &&
        currentTimeRange?.length === 1 &&
        currentTimeRange?.includes(time)
      );
    },

    showService(service) {
      this.$modal.show("service-modal", { id: service.id });
    },

    isShowRelatedOrShortDescription(service) {
      return (
        service.related_services?.length ||
        this.$options.filters.localeField(service, "short_description")
      );
    },

    showAdditionalParamTab(i, handler) {
      handler(i);
      if (this.additionalParamTab === i) {
        this.additionalParamTab = null;
        return null;
      }
      this.additionalParamTab = i;
    },

    syncQuantityByDate(service, quantity, date) {
      clearTimeout(this.quantityByDateDebounce);
      this.quantityByDateDebounce = setTimeout(() => {
        this.rowsModified
          .filter(row => row.id === service.id)
          .forEach(row => {
            const currentQuantityByDate = row.quantity_by_dates.find(item =>
              moment(item.date).isSame(moment(date), "day")
            );
            if (currentQuantityByDate) {
              if (quantity) {
                currentQuantityByDate.quantity = quantity;
              } else {
                row.quantity_by_dates = row.quantity_by_dates.filter(
                  item => !moment(item.date).isSame(moment(date), "day")
                );
              }
            } else {
              if (quantity) {
                row.quantity_by_dates.push({
                  date: moment(date).format("YYYY-MM-DD"),
                  quantity: quantity
                });
              }
            }
            this.recalculateRowCountAfterChangeQuantityByDate(row);
          });
      }, 500);
    },

    recalculateRowCountAfterChangeQuantityByDate(service) {
      this.rowsModified
        .filter(row => row.id === service.id)
        .forEach(row => {
          row.count = row.quantity_by_dates.reduce(
            (result, countByDate) => countByDate.quantity + result,
            0
          );
        });

      this.componentKey++;
      this.handleDebounce(service);
    },

    syncTimeRangeByDate(value, service, time, date) {
      this.rowsModified
        .filter(row => row.id === service.id)
        .forEach(row => {
          const currentTimeRangeByDate = row.time_range_by_dates.find(item =>
            moment(item.date).isSame(moment(date), "day")
          );

          if (currentTimeRangeByDate) {
            if (value) {
              currentTimeRangeByDate.time_range.push(time);
            } else {
              currentTimeRangeByDate.time_range = currentTimeRangeByDate.time_range.filter(
                item => item !== time
              );

              if (!currentTimeRangeByDate.time_range.length) {
                row.time_range_by_dates = row.time_range_by_dates.filter(
                  item => !moment(item.date).isSame(moment(date), "day")
                );
              }
            }
          } else {
            if (value) {
              row.time_range_by_dates.push({
                date: moment(date).format("YYYY-MM-DD"),
                time_range: [time]
              });
            }
          }
        });
    },

    recalculateRowCountAfterChangeTimeRangeByDate(service) {
      this.rowsModified
        .filter(row => row.id === service.id)
        .forEach(row => {
          row.count = row.time_range_by_dates.reduce(
            (result, timeRangeByDate) =>
              (timeRangeByDate.time_range?.length || 0) + result,
            0
          );
        });
      this.componentKey++;
      if (service.count) {
        this.handleDebounce(service);
      } else if (this.isServiceInCart(service)) {
        this.deleteFromCart(service);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.services-list-table {
  &__form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
    padding: 15px;
  }

  &__form-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;

    > span {
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
    }
  }

  &__button {
    background: none;
    border: 1px solid var(--gray-darker);
    border-radius: 2px;
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    gap: 8px;
    .icon {
      display: inline-flex;
      position: relative;
    }

    &--delete {
      border: none;
    }

    &--wide {
      width: 100%;
    }

    &--light &-counter {
      background: var(--white);
      color: var(--main);
      right: 4px;
      top: 4px;
      transform: none;
    }

    &--wide &-counter {
      right: -4px;
      top: -4px;
    }

    &--light {
      background: var(--main);
      border-color: var(--main);

      svg {
        color: var(--white) !important;
      }
    }
    &:hover {
      background: var(--main-dark);
      svg {
        color: var(--white);
      }
    }

    .svg-icon {
      transition: 0.3s;
      color: var(--main-dark);
      margin: 0 !important;
      width: 20px;
      height: 20px;
    }
  }

  &__button-counter {
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(50%, -50%);
    color: var(--white);
    background: var(--main-dark);
    border-radius: 100%;
    width: 15px;
    height: 15px;
    border: 1px solid var(--white);
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &__popular {
    padding: 15px;
    background: var(--main-bg);
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: calc(100vw - 36px);

    &-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      background: none;
      cursor: pointer;
      border: none;
      height: auto;
      align-items: center;

      span {
        font-size: 1em;
        font-style: normal;
        line-height: 24px;
        margin: 0;
        color: var(--gray-dark);
      }

      &--open svg {
        transform: rotate(180deg);
      }

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  &__time-range {
    &--tooltip {
      display: flex;
      padding: 15px;
    }
    &--content {
      flex-direction: column;
      display: flex;
      gap: 10px;
    }
  }
  &__executor {
    padding: 10px;
    font-feature-settings: "clig" off, "liga" off;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 22px;
    background: var(--main-bg, #f0f5f9);
  }

  &__comment {
    padding: 15px;
    display: flex;
    flex-direction: column;

    &-title {
      color: var(--dark-light, #6d7179);
      font-feature-settings: "clig" off, "liga" off;
      font-size: 0.75rem;
      line-height: 18px;
      margin-bottom: 5px;
    }

    &-field {
      border-radius: 2px;
      border: 1px solid var(--gray-darker, #d5dae5);
      padding: 10px 15px;
      height: 50px;

      &::placeholder {
        color: var(--gray-dark, #a3a8b3);
      }
    }
  }

  &__quantity-by-date {
    display: inline-flex;

    @media (max-width: 740px) {
      display: none;
    }
  }
}

.table {
  td.active-top {
    border-top: 2px solid var(--main-dark);

    &:first-child {
      border-left: 2px solid var(--main-dark);
    }

    &:last-child {
      border-right: 2px solid var(--main-dark);
    }
  }

  td.no-wrap {
    white-space: nowrap;
  }

  tr.active-bottom td {
    border-bottom: 2px solid var(--main-dark);

    &:first-child {
      border-left: 2px solid var(--main-dark);
    }

    &:last-child {
      border-right: 2px solid var(--main-dark);
    }
  }

  tr.active-left-and-right td {
    &:first-child {
      border-left: 2px solid var(--main-dark);
    }

    &:last-child {
      border-right: 2px solid var(--main-dark);
    }
  }

  &-align-center {
    display: block;
    text-align: center;
  }

  .event-popular-services__list {
    margin-top: 20px;
  }
  & .datepicker-tooltip {
    right: 50%;
    transform: translateX(50%);
    &:after {
      right: 45%;
    }
  }
  & tr.light-blue {
    background-color: #c8e2ed;
  }
  & tr.blue {
    background-color: #add8e6;
  }
}
.table-item-name {
  transition: color var(--transition, 0.2s);
  &:hover {
    color: var(--main-dark, #005197);
  }
}
.time-wrap {
  display: inline-block;
  height: 40px;
  outline: none;
  position: relative;
  background-color: var(--white);
}
</style>
